import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24a72188"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "edit-form" }
const _hoisted_3 = { class: "login" }
const _hoisted_4 = { class: "login-body" }
const _hoisted_5 = {
  key: 0,
  class: "error-message"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "Email", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "Password", -1))
const _hoisted_8 = { class: "submit-container" }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.showFormError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Email or Password is invalid"))
            : _createCommentVNode("", true),
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            placeholder: "Email",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.email]
          ]),
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "password",
            class: "form-control",
            placeholder: "Password",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
            onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.password]
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              class: "btn btn-outline-primary",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetPassword && _ctx.resetPassword(...args)))
            }, "Forgot Password?"),
            _createElementVNode("button", {
              class: "btn btn-primary",
              disabled: !_ctx.isFormValid || _ctx.isLoading,
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)))
            }, "Login", 8, _hoisted_9)
          ])
        ])
      ])
    ])
  ]))
}